import agent from "../../new_relic"

export const logCustomException = async (msg, attr = {}) => {
    let res = agent.api.noticeError(new Error(msg), attr);
}

export const logException = async (error, attr = {}) => {
    let res = agent.api.noticeError(error, attr);
}

export const setUserID = async (user_id) => {
    let res = agent.api.setUserId(user_id)
}